<template>
  <div class="subheader subheader--pills">
    <div class="bet-type">

      <div :class="['type',(getBet.type == 'single' || getBet.type == 'multiple') ? 'active' : '']"
           @click="changeTypeCart('multiple')">
        <span v-if="getBet.type == 'single' && getSettings.single">{{ $t('single') }}</span>
        <span v-else>{{ $t('multiple') }}</span>
      </div>
      <div
              :class="['type', (getBet.type == 'integral') ? 'active' : '']" @click="changeTypeCart('integral')"
              v-if="getSettings.integral"
      >
        <span>{{ $t('integral') }}</span>
      </div>
      <div
              :class="['type', (getBet.type == 'system') ? 'active' : '', (getBet.type == 'integral' || getBet.type == 'single' || getBet.odds.length == 1 || getBet.odds.length > 10 || hasBetBuilder)? 'disabled': '']"
              @click="changeTypeCart('system')"
              v-if="getSettings.system"
      >
        <span>{{ $t('system') }}</span>
      </div>
    </div>
    <div class="delete-all pointer" @click="clearCart">
      <span>{{ $t('cartSheet.clearAll') }}</span>
      <v-icon dense>mdi-delete</v-icon>
    </div>
  </div>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'BetTypeSelector',
    data: () => ({}),
    computed: {
      ...mapGetters({
        'getBet': 'cart/getBet',
        'getSettings': 'cart/getSettings',
        'hasBetBuilder': 'cart/hasBetBuilder',
      }),

    },
    methods: {
      async clearCart() {
        // this.showCopy = false
        // this.dialog = false
        // this.dialogError = false
        // this.warningOddsChanged = false
        // this.showAlertLogin = false
        this.$root.$emit('cart_handling', true)
        await this.resetCart()
      },
      ...mapActions({
        'refreshCart': 'cart/refreshCart',
        'setBetType': 'cart/setBetType',
        'resetCart': 'cart/resetCart',
      }),

      async changeTypeCart(type) {

        //console.log('changeTypeCart to -> ' + type)

        var vue = this

        if (vue.getBet.odds.length > 10 && type == 'system') {
          return
        }

        if (vue.getBet.type === 'integral' && type === 'system') {
          return
        }

        if (vue.getBet.type != 'simple' && vue.getBet.odds.length > 1) {
          await this.setBetType({'type': type})
          await this.refreshCart()
        }

      },

    },

  };
</script>

<style scoped>
/* ── Subheader container ─────────────────────────────────── */
.subheader {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
}

/* ── Bet type tabs ───────────────────────────────────────── */
.bet-type {
    display: flex;
    align-items: center;
    padding: 0 4px;
    gap: 0;
}

.type {
    font-size: var(--font-size-2xl);
    font-weight: 400;
    text-transform: capitalize;
    padding: 2px 10px;
    cursor: pointer;
    color: #8a94a6;
    border-bottom: 2px solid transparent;
    transition: color 0.15s, border-color 0.15s;
    white-space: nowrap;
    user-select: none;
}

.type.active {
    color: var(--text-platform);
    font-weight: 600;
    border-bottom-color: var(--color-primary, #007aff);
}

.type.disabled {
    color: #3e4654;
    cursor: not-allowed;
}

.type:not(.disabled):not(.active):hover {
    color: #c2cad6;
}

/* ── Delete all button ───────────────────────────────────── */
.delete-all {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    font-size: var(--font-size-xl);
    color: #5c697a;
    cursor: pointer;
    transition: color 0.15s;
    white-space: nowrap;
    user-select: none;
}

.delete-all:hover {
    color: #ef4444;
}

.delete-all .v-icon {
    font-size: var(--font-size-6xl) !important;
    color: inherit !important;
}

.delete-all span {
    padding-right: 0;
}

/* ── Pillole tipo scommessa ──────────────────────────────── */
.subheader--pills {
    align-items: center;
    gap: 8px;
    container-type: inline-size;
}

.subheader--pills .bet-type {
    gap: 6px;
    padding: 0;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;
}

.subheader--pills .bet-type::-webkit-scrollbar {
    display: none;
}

.subheader--pills .type {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 12px;
    border: 1px solid var(--border-color, rgba(255,255,255,0.1));
    border-radius: 999px;
    background: var(--bg-card);
    font-size: var(--font-size-2xl);
    font-weight: 500;
    transition: color 0.15s, border-color 0.15s, background 0.15s;
}

.subheader--pills .type.active {
    color: var(--text-platform);
    font-weight: 700;
    border-color: var(--color-primary-light);
    background: var(--color-primary-op, rgba(255,255,255,0.06));
}

.subheader--pills .type.disabled {
    opacity: 0.45;
}

.subheader--pills .delete-all {
    flex-shrink: 0;
    padding: 8px 0 8px 4px;
    font-size: var(--font-size-2xl);
    color: var(--text-op-50-platform);
}

/* Colonna stretta (sidebar desktop): solo icona cestino, spazio alle pillole */
@container (max-width: 330px) {
    .subheader--pills .delete-all span {
        display: none;
    }
}
</style>